<template>
  <v-dialog
    v-model="show"
    persistent
    transition="dialog-bottom-transition"
    max-width="500">
    <v-card>
      <v-app-bar flat dark color="primary">
        <v-toolbar-title>Abrechnung(en) veröffentlichen</v-toolbar-title>
      </v-app-bar>
      <v-card>
        <v-card-text v-if="yearMonth">
          Möchten sie die Abrechnungen des Monats <b>{{mapYearMonth(yearMonth)}}</b> wirklich veröffentlichen?
        </v-card-text>
        <v-card-text v-else-if="invoices && invoices.length > 1">
          Möchten sie die <b>{{invoices.length}}</b> Abrechnungen wirklich veröffentlichen?
        </v-card-text>
        <v-card-text v-else-if="invoice && invoice.type === 'CUSTOMER_INVOICE'">
          Sie möchten die Abrechnung für den Kunden <b>{{invoice.customer.lastName}} {{invoice.customer.firstName}}</b>
          wirklich veröffentlichen?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="$emit('cancel')"
          >
            Abbrechen
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="blue"
            text
            @click="release"
          >
            Veröffentlichen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'ReleaseInvoiceConfirmDialog',
    props: {
      show: {
        type: Boolean,
        default: false
      },
      invoice: {
        type: Object,
        default: function () {
          return {
            id: 0,
            released: false,
            type: '',
            customer: {
              lastName: '',
              firstName: ''
            }
          }
        }
      },
      invoices: {
        type: Array,
        default: function () {
          return []
        }
      },
      yearMonth: {
        type: String,
        default: ''
      }
    },
    methods: {
      mapYearMonth: function (yearMonth) {
        const splitted = yearMonth.split('-')
        const date = new Date(splitted[0], splitted[1] - 1)
        return date.toLocaleString('de-de', {month: 'long'}) + ' ' + splitted[0]
      },
      release: function () {
        if (this.yearMonth) {
          this.$store.dispatch('bulkInvoiceReleaseByMonth', this.yearMonth)
            .finally(() => this.$emit('close'))
        } else if (this.invoices && this.invoices.length > 1) {
          this.$store.dispatch('bulkInvoiceReleaseByInvoices', this.invoices)
            .finally(() => this.$emit('close'))
        } else if (this.invoice.id !== 0) {
          this.$store.dispatch('releaseInvoice', this.invoice.id)
            .finally(() => this.$emit('close'))
        }
      }
    }
  }
</script>

<style scoped>
  .v-subheader {
    margin-left: -32px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Invoices/ReleaseInvoiceConfirmDialog.vue